/** A cluster displayed on a map. A cluster contains (size) element, its center is a (clon, clat) */
export class MapCluster {
    
    constructor(public size:number, public clon:number, public clat:number) {}

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/data/map-cluster.ts